import React, { useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../Utils/Nav";
import Footer from "../Utils/Footer";
import "../Css/Consultancy.css";

import mammoth from "mammoth"; // Make sure mammoth is installed

const data = [
  {
    "id": 1,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Proposed Hotel Building, Jalandhar",
    "client": "Golden View Hotel"
  },
  {
    "id": 2,
    "researcher": "Dr. Sagar Rohidas Chavan",
    "title": "External Expert for Monitoring the Project 'Development of Inflow Forecasting System for Ranjit Sagar Dam and Inundation Forecasting Downstream of Ranjit Sagar Dam'",
    "client": "Project & RM Division, Ranjit Sagar Dam"
  },
  {
    "id": 3,
    "researcher": "Dr. Putul Haldar",
    "title": "Vetting of Structural Drawings of ESR B05, Chakan Project",
    "client": "Wani Projects & Infra Pvt. Ltd."
  },
  {
    "id": 4,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural and Technical Audit of Bottling Plant",
    "client": "M/s Queen Distillers and Bottlers Pvt. Ltd."
  },
  {
    "id": 5,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Arnaila Dam",
    "client": "WRD Punjab"
  },
  {
    "id": 6,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Bichhahi Dam",
    "client": "WRD Punjab"
  },
  {
    "id": 7,
    "researcher": "Dr. Rahul TM",
    "title": "Vetting of Flexible Pavement Design",
    "client": "Civilified Infra Consultants Pvt. Ltd."
  },
  {
    "id": 8,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Chak Sadhu Dam in District Hoshiarpur",
    "client": "Executive Engineer, Kandi Watershed Drainage Division, Hoshiarpur"
  },
  {
    "id": 9,
    "researcher": "Dr. Putul Haldar",
    "title": "Condition Assessment of Floor Structure of MSME Building at Kanpur",
    "client": "MSME Technology Centre, Kanpur"
  },
  {
    "id": 10,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana",
    "title": "Vetting of Preliminary Drawings of Proposed Commercial Complex Owned by Mr. Mahesh Sharma and Mrs. Benu Mahesh Sharma at Pathankot",
    "client": "Mr. Mahesh Sharma and Mrs. Benu Mahesh Sharma"
  },
  {
    "id": 11,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the RCC Components of the Bridge on RAS-Beawar Section",
    "client": "K4 Ideas & Infra Private Ltd"
  },
  {
    "id": 12,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Aviation Hangar, Dehradun",
    "client": "bnal Prefab Pvt. Ltd."
  },
  {
    "id": 13,
    "researcher": "Dr. Naveen James",
    "title": "Conducting Soil Dynamics Lab Experiments",
    "client": "HoD, IKG PTU Jalandhar"
  },
  {
    "id": 14,
    "researcher": "Dr. Naveen James",
    "title": "Vetting of the Load Carrying Capacity of Piles Based on the Available Test Data",
    "client": "GEO-PRO Consultancy & Construction"
  },
  {
    "id": 15,
    "researcher": "Dr. Putul Haldar (CI) and SP Tech Design LLP",
    "title": "Vetting of Structural Drawings of 'Engine Manufacturing Facility at Igatpuri'",
    "client": "Group Surya"
  },
  {
    "id": 16,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana",
    "title": "Vetting of Drawings of Boundary Wall Owned by Garrison Engineer Military Engineering, Pithoragarh",
    "client": "Interstellar Testing Centre Pvt. Ltd., Panchkula"
  },
  {
    "id": 17,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Substructure Design and Drawings for Viaduct on Daulatpur Chowk Talwara Section in Connection with NLDM-TLR-MEX New B.G. Line",
    "client": "HMM INFRA Ltd."
  },
  {
    "id": 18,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Launching Methodology Drawing of Steel Truss 51MTR Span for DMRC",
    "client": "HMM INFRA Ltd."
  },
  {
    "id": 19,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of ROB 407 & 407B on Jhansi-Gwalior Section",
    "client": "JC Technocrats Pvt. Ltd."
  },
  {
    "id": 20,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Fire Pump WTP Pump Room and Production Unit at Nashik",
    "client": "Steel Build Infra Projects Pvt. Ltd."
  },
  {
    "id": 21,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Construction of 40m Through Type Steel Truss Girder Motorable Bridge on Ikhala Block Boundary Kishtwae to Lopara Road",
    "client": "MIR Fabricators & Engineers"
  },
  {
    "id": 22,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Construction of 60m Span Through Type Steel Truss Girder Motorable Bridge on Malikote to Sarsote Road",
    "client": "MIR Fabricators & Engineers"
  },
  {
    "id": 23,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of the Design & Drawings of BOPP-9 Building",
    "client": "SteelBuild Infra Projects Pvt. Ltd."
  },
  {
    "id": 24,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Launching Scheme Between DDU and Ganjkhwaja Stations & Road Ch. 56.216 KM of Varanasi Ring Road",
    "client": "HMM INFRA Ltd."
  },
  {
    "id": 25,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Launching Methodology of ROB at Design CH-146+530.5",
    "client": "HMM INFRA Ltd."
  },
  {
    "id": 26,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "Premier Alcobev Pvt. Ltd."
  },
  {
    "id": 27,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "M/s Sabacchus Distiller Pvt. Ltd."
  },
  {
    "id": 28,
    "researcher": "Dr. Reet Kamal Tiwari and Dr. Sayaantan Ganguly",
    "title": "River Audit Work",
    "client": "Director Mining & Geology, Mining & Geology Dept. Chandigarh (Punjab Govt.)"
  },
  {
    "id": 29,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "Himalayan Gold Beverages Pvt. Ltd."
  },
  {
    "id": 30,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "North India Distillers & Bottlers Pvt. Ltd."
  },
  {
    "id": 31,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "Country Liquor Bottling Plant, HP (Govt.)"
  },
  {
    "id": 32,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "M/s VRV Foods Ltd."
  },
  {
    "id": 33,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana",
    "title": "Vetting of Drawings of Residential Structure of Deficient Servant Qtr and Garages for BLDG No. P-1, P-2 & P-3 at 12 BRD AF",
    "client": "Shiva Testing Research Laboratory Pvt. Ltd., Baddi"
  },
  {
    "id": 34,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana",
    "title": "Vetting of Drawings of Cast-in-situ U-type Longitudinal Drain with Cover at MIL.STN. Pithoragarh",
    "client": "Interstellar Testing Centre Pvt. Ltd., Panchkula"
  },
  {
    "id": 35,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "M/s Kala AMB Distillery and Brewery Pvt. Ltd."
  },
  {
    "id": 36,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural Audit and Technical Audit of Bottling Plant",
    "client": "M/s RR Bottlers and Distilleries"
  },
  {
    "id": 37,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural and Technical Audit of Alcobrew Distilleries India Ltd. (Bottling Plant & Distillery)",
    "client": "Alcobrew Distilleries India Ltd."
  },
  {
    "id": 38,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural and Technical Audit of Mohan Meakin Ltd. Solan Brewery (Bottling Plant & Distillery)",
    "client": "Mohan Meakin Ltd. Solan Brewery"
  },
  {
    "id": 39,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Construction of 65m Span Through Type Steel Truss Girder Motorable Bridge on Malikote to Sarsote Road",
    "client": "MIR Fabrications & Engineers"
  },
  {
    "id": 40,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of H.P. Housing & UDA Shimla",
    "client": "BALDEV Bantu Sharma"
  },
  {
    "id": 41,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Construction of 40m Through Type Steel Truss Girder Motorable Bridge on Ikhala Block Boundary Kishtwae to Lopara Road",
    "client": "MIR Fabrications & Engineers"
  },
  {
    "id": 42,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Widening & Improvement of Chotta Shimla Kasumpti Smart City",
    "client": "Geotech Engineers and Consultants"
  },
  {
    "id": 43,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of 60.0m Span PMT Steel Bridge Steel over Jambhir Nallah at Km 12.630 on Road Balavanue-Dharal-Lam",
    "client": "V.P Sharma Govt. Contractor"
  },
  {
    "id": 44,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of 46m Long Through Type Steel Truss Girder Motorable Bridge on Angralla to Gulabgarh Road",
    "client": "MIR Fabrications & Engineers"
  },
  {
    "id": 45,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of TOTA Bridge 70.0m Span over Kishan Ganga River at KM 66.950",
    "client": "Navnirman Construction Company"
  },
  {
    "id": 46,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Takrala-1 Dam Site",
    "client": "Kandi Area Dam Maintenance Division, Hoshiarpur (Govt.)"
  },
  {
    "id": 47,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Takrala-2 Dam Site",
    "client": "Kandi Area Dam Maintenance Division, Hoshiarpur (Govt.)"
  },
  {
    "id": 48,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Mohan Majra Dam Site",
    "client": "Kandi Area Dam Maintenance Division, Hoshiarpur (Govt.)"
  },
  {
    "id": 49,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Ram Tatwali Dam Site",
    "client": "Kandi Area Dam Maintenance Division, Hoshiarpur (Govt.)"
  },
  {
    "id": 50,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Shifting of Benchmark at Sialba Dam Site",
    "client": "Kandi Area Dam Maintenance Division, Hoshiarpur (Govt.)"
  }, {
    "id": 51,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of 15mtr. Span Single Lane Steel Motorable Bridge, Harog to Halla Road",
    "client": "Prince Constructions"
  },
  {
    "id": 52,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Precast Box Culverts of 2m & 3m Span",
    "client": "Sanjeev Kumar Goyal Contractor"
  },
  {
    "id": 53,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Revised Design & Drawings of Kendriya Vidhyalaya Samiti",
    "client": "10 Decimal Design Studio"
  },
  {
    "id": 54,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of KV Manipur",
    "client": "10 Decimal Design Studio"
  },
  {
    "id": 55,
    "researcher": "Dr. Aditya Singh Rajput, Dr. Mitesh Surana",
    "title": "Vetting of Structural Drawings of High-Rise Group Housing Tower at Gwal Pahari",
    "client": "M/s Kvell Infrastructure LLP, Gurugram (Haryana)"
  },
  {
    "id": 56,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of KAHDI Mall at Muzaffarpur",
    "client": "Ranea Enterprises"
  },
  {
    "id": 57,
    "researcher": "Dr. Putul Haldar",
    "title": "Vetting of Structural Drawings of 'Environment House at Bhosari, Pune (Maharashtra)'",
    "client": "GS PEB & CIVIL WORKS PVT LTD"
  },
  {
    "id": 58,
    "researcher": "Dr. Putul Haldar (CI), Dr. Indramani Dhada (Co-CI)",
    "title": "Assessment of Cement Fiber Board (CFB) used for Facade Work at MSME Building at Baddi and Rohtak",
    "client": "MSME Technology Centre, Ludhiana"
  },
  {
    "id": 59,
    "researcher": "Dr. Putul Haldar (CI), Dr. Indramani Dhada (Co-CI)",
    "title": "Assessment of Cement Fiber Board (CFB) used for Facade Work at MSME at Kanpur",
    "client": "MSME Technology Centre, Kanpur"
  },
  {
    "id": 60,
    "researcher": "Dr. Naveen James",
    "title": "Vetting of the Report on Soil Investigation for Provision of Deficient Married Accn for Officers (Lt. Cdr & Above) at Nora, Amzari PARK, Visakhapatnam",
    "client": "Shiva Testing Research Laboratory, Pvt. Ltd., Baddi"
  },
  {
    "id": 61,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Stability test of flood-affected buildings in Panchvati Enclave, Guru Teg Bahadur Nagar, Kharar",
    "client": "Mr. Rajesh Sharma, Junior Engineer, Municipal Council, Kharar, Punjab"
  },
  {
    "id": 62,
    "researcher": "Dr. Indramani Dhada",
    "title": "Consultancy of Biomining/Bio-remediation of Dadumajra, Chandigarh (8-acre site)",
    "client": "Municipal Corporation, Chandigarh"
  },
  {
    "id": 63,
    "researcher": "Dr. Putul Haldar (CI) & Mr. Ritu Raj Nath (External Consultant)",
    "title": "Vetting of Structural Drawings of 'Proposed Warehouse at ESR Park; B03 & B04, Chakan, Pune'",
    "client": "Wani Projects & Infra Pvt. Ltd."
  },
  {
    "id": 64,
    "researcher": "Dr. Naveen James",
    "title": "Vetting of the soil investigation Reports for GE (I) (P) No. 1 Leh",
    "client": "Shiva Testing Research Laboratory, Pvt. Ltd., Baddi, Solan, HP"
  },
  {
    "id": 65,
    "researcher": "Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Structural Drawings and Design of retaining wall in AF Stn Chandigarh",
    "client": "Subhash Anita & Associates"
  },
  {
    "id": 66,
    "researcher": "Dr. Naveen James and Dr. Reet Kamal Tiwari (CI)",
    "title": "Site Visit and Visual Assessment of Landslide Areas at Jutogh and Chail",
    "client": "Garrison Engineer (I) Jutogh, Shimla, HP (pvt.)"
  },
  {
    "id": 67,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Various Stagings of OHTs",
    "client": "Integral Screw Industries"
  },
  {
    "id": 68,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of 35m Span Major PMT Bridge on Road Khaltsi-Batalik",
    "client": "New Jehlum Construction Co"
  },
  {
    "id": 69,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of design & drawing for foundation and substructure of bridges for various projects",
    "client": "India Ltd"
  },
  {
    "id": 70,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of design & drawing for foundation and substructure in connection with new bridges for doubling work between Jaunpur-Akbarpur section",
    "client": "Bridge & Roof Company India Ltd"
  },
  {
    "id": 71,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of design of bearings for 60m RDSO",
    "client": "Shree Balaji Engineering Works"
  },
  {
    "id": 72,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof checking of design and drawings of bearings for ROB 426+781 & 440+218",
    "client": "CECO Infratech Pvt. Ltd."
  },
  {
    "id": 73,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural and Technical Audit of Bottling Plant",
    "client": "M/s Himgiri Beverages"
  },
  {
    "id": 74,
    "researcher": "Dr. Aditya Singh Rajput",
    "title": "Carrying out a condition assessment of 104 Twin tube Piezometers at Narayanpur Dam and providing a method of the revival of the installed piezometer, including detailed BoQ",
    "client": "Executive Engineer, KBJNL, Dam Division, Narayanpur, Karnataka"
  },
  {
    "id": 75,
    "researcher": "Dr. Aditya Singh Rajput & Dr. Mitesh Surana (CI)",
    "title": "Vetting of Structural Drawings of the Medallion Aurum, Group Housing Site, Sector-67, Mohali, Punjab by Turnstone Realty LLP",
    "client": "Turnstone Realty LLP"
  },
  {
    "id": 76,
    "researcher": "Dr. Aditya Singh Rajput & Dr. Mitesh Surana (CI)",
    "title": "Interpretation of CCTV survey and providing expert advice to assess the structural stability condition of sewer lines and stormwater drain in Ludhiana",
    "client": "O&M, Municipal Corporation, Ludhiana, Punjab"
  },
  {
    "id": 77,
    "researcher": "Dr. Aditya Singh Rajput & Dr. Mitesh Surana (CI)",
    "title": "Conducting the structural stability test of plant building at National Fertilizers Limited (NFL) Nangal Unit",
    "client": "National Fertilizers Limited"
  },
  {
    "id": 78,
    "researcher": "Dr. Naveen James",
    "title": "Vetting of the soil investigation Reports for Provision of Deficient Married Accn for Officers at Ratnagiri",
    "client": "Shiva Testing and Research Laboratory Pvt Ltd, Baddi, Solan"
  },
  {
    "id": 79,
    "researcher": "Dr. Naveen James (CI) and Dr. Aditya Singh Rajput, Dr. Reet Kamal Tiwari (Co-CI)",
    "title": "Proposing the Slope Rehabilitation Measures for Sites Near RMS Chail Himachal Pradesh",
    "client": "Military Engineering Services, (MES) Jutogh Cantt, Shimla"
  },
  {
    "id": 80,
    "researcher": "Dr. Aditya Singh Rajput, Dr. Naveen Jamesh and Reet Kamal Tiwari (CI)",
    "title": "Field visit to the landslide site in Subathu Cantonment Area, Himachal Pradesh",
    "client": "Mr. Rahul Meena, IDSE, EE, Garrison Engineer, MES"
  },
  {
    "id": 81,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking Commercial Project, Amritsar",
    "client": "IMPACT Projects Pvt. Ltd"
  },
  {
    "id": 82,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof checking of structural design and drawings of storage tanks",
    "client": "Everyday steel storage Pvt. Ltd."
  },
  {
    "id": 83,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof checking Detailed Design & Drawings of FOB at B-22",
    "client": "Amritsar Improvement trust, Amritsar, Punjab"
  },
  {
    "id": 84,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Naveen James (CI)",
    "title": "Vetting of Structural Drawings and Design of retaining wall",
    "client": "STR Labs (Pvt.)"
  },
  {
    "id": 85,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of 85.0m Span PMT Steel Bridge over Kishan Ganga River",
    "client": "Agastya Engineers Pvt. Ltd."
  },
  {
    "id": 86,
    "researcher": "Dr. Naveen James",
    "title": "Vetting of the Soil Investigation Report for Engineering Procurement & Construction (EPC) of Provision of Storage Sheds Including Ancillary Buildings at MUNAKOT Mil Station",
    "client": "National Soil Testing & Research Lab Pithoragarh (Report - 2) BH 46 to BH 82"
  },
  {
    "id": 87,
    "researcher": "Dr. Indramani Dhada",
    "title": "Rapid Assessment and Suggestion for Mitigation of Particulate Matter Emission in the Cements Plant: Ambuja Cements Ltd., Ropar, Punjab",
    "client": "Ambuja Cements Ltd"
  },
  {
    "id": 88,
    "researcher": "Dr. Naveen James",
    "title": "Vetting of the Soil Investigation Report for Engineering Procurement & Construction (EPC) of Provision of Storage Sheds Including Ancillary Buildings at MUNAKOT Mil Station",
    "client": "National Soil Testing & Research Lab Pithoragarh (Report - 1) BH 1 to BH 45"
  },
  {
    "id": 89,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of LAWRENCE ROAD project",
    "client": "Vetta Engineering (OPC) Pvt. Ltd."
  },
  {
    "id": 90,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of LAWRENCE ROAD project",
    "client": "JC Technocrats Pvt. Ltd."
  },
  {
    "id": 91,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of LAWRENCE ROAD project",
    "client": "KIRANOTECH Engineering Consultancy Pvt. Ltd."
  },
  {
    "id": 92,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural and Technical Audit of Bottling Plant",
    "client": "High Sprit Food and Beverages"
  },
  {
    "id": 93,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the launching methodology for bridges over Pagal Nallah and Rimkhim Gad",
    "client": "M/s SGF Infra Pvt. Ltd."
  },
  {
    "id": 94,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof checking of Design and Drawing of Mill Tower",
    "client": "DE HEUS ANIMAL NUTRITION INDIA PVT. LTD."
  },
  {
    "id": 95,
    "researcher": "Dr. Naveen James, Dr. Aditya Singh Rajput and Reet Kamal Tiwari",
    "title": "Proposing the Slope Rehabilitation Measures for Sites Near RMS Chail Himachal Pradesh",
    "client": "MES, Jutogh Cantt., Shimla"
  },
  {
    "id": 96,
    "researcher": "Dr. Sagar Rohidas Chavan",
    "title": "Assessment of Surface water available in the Downstream of Madhopur Headworks on Ravi River within Indian Territory",
    "client": "Water Resources Deptt. Punjab"
  },
  {
    "id": 97,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Launching Scheme of Bow String Girder (clean span = 72.00M)",
    "client": "M/S P & R Infraprojects Ltd"
  },
  {
    "id": 98,
    "researcher": "Dr. Reet Kamal Tiwari (CI) & Dr. Sagar Rohidas Chavan (Co-CI)",
    "title": "Proposal for fixing alignment for bringing water from Yamuna to Punjab",
    "client": "Water Resources Deptt. Punjab"
  },
  {
    "id": 99,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of warehouse building, Sambha",
    "client": "M/s Bnal Prefab Pvt. Ltd"
  },
  {
    "id": 100,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of B+G+5 storey IT building",
    "client": "M/s EON Infotech ltd"
  },
  {
    "id": 101,
    "researcher": "Dr. Indramani Dhada",
    "title": "Structural and Technical Audit of Bottling Plant",
    "client": "High Sprit Food and Beverages (Pvt.)"
  },
  {
    "id": 102,
    "researcher": "Dr. Putul Haldar",
    "title": "Vetting of Structural Drawings of 'Mahindra BIW shop-Chakan'",
    "client": "Group Surya"
  },
  {
    "id": 103,
    "researcher": "Dr. Putul Haldar",
    "title": "Structural Damage Assessment due to Flood; MSME Technology Centre - Baddi, Himachal Pradesh",
    "client": "MSME Technology Centre, Ludhiana"
  },
  {
    "id": 104,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Design and Drawings of Proposed Hospital Building Belonging to Dr. Sukhjit Singh at Sutehri Road, Hoshiarpur",
    "client": "SDP Builders, EPC Contractors"
  },
  {
    "id": 105,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Preliminary Submission Drawings and Issuing Structural Stability Certification for College and Hostel Building at Greater Noida for Client M/S Shri Ram Education Trust",
    "client": "Constructive Ideas, M/s Shri Ram Education Trust"
  },
  {
    "id": 106,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Structural Drawings and Design of Retaining Wall",
    "client": "Military Engineering Service"
  },
  {
    "id": 107,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Proof Checking of Structural Drawings of 'Stilt+20 Storey Tower for Group Housing Project, Sheesh Mahal Sky View, owned by Sheesh Mahal Developers Limited, Dabwali Road, Bathinda'",
    "client": "Sheesh Mahal Developers Limited, Dabwali Road, Bathinda"
  },
  {
    "id": 108,
    "researcher": "Dr. Reet Kamal Tiwari",
    "title": "Inspection of Railway Girder Bridge Using UAVs, Lidar, Photogrammetry and Similar Technologies for Indian Railways",
    "client": "A D Northern Railway"
  },
  {
    "id": 109,
    "researcher": "Dr. Naveen James",
    "title": "Soil Investigation for Provision of 02x20 Men, 2x70JCO/OR Barracks along with Attached Toilets under Garrison Engineer, Pratapur under AMWO 2022-23",
    "client": "Shiva Testing and Research Laboratory Pvt. Ltd"
  },
  {
    "id": 110,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Structural Drawings of 3B+G+3 Story Commercial Buildings for Malhotra Realty Limited, Ludhiana",
    "client": "Malhotra Realty Pvt. Ltd."
  },
  {
    "id": 111,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana",
    "title": "Vetting of Preliminary Submission Drawings and Issuing Structural Stability Certification for Budget Hotel Building Blue Moon Central at Village Noor Nagar Ghaziabad Client M/S Progressive Constructions",
    "client": "Constructive Ideas, M/s Progressive Constructions"
  },
  {
    "id": 112,
    "researcher": "Dr. Indramani Dhada (CI), Dr. Bibhu Prasad Padhy & Dr. Ranjan Das (Co-CI)",
    "title": "Partial Completion Certificate/report in respect of Aero Business Park Manakpur Kallar",
    "client": "Landchester Infrastructure Associates"
  },
  {
    "id": 113,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Design and Drawing of RE Wall",
    "client": "Khara Contractors Uttarakhand (Pvt)"
  },
  {
    "id": 114,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Fabrication Drawings of Sunni Bridge",
    "client": "M/s P&R Infraprojects Ltd."
  },
  {
    "id": 115,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Structural Audit of CH 35 (Block A, B & C), MES, Chandimandir",
    "client": "Garrison Engineer Utility Chandimandir"
  },
  {
    "id": 116,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Single Living Accommodation JCO (G+2)",
    "client": "M/S NSC Projects Pvt. Ltd"
  },
  {
    "id": 117,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of 3 Nos. of Bridges: Tundla-Ghaziabad Section in Prayagraj Division of North Central Railway, Khukhrana Railway Station in Panipat",
    "client": "M/S Singhal Group of Engineers"
  },
  {
    "id": 118,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of ROB at LC No. 78 (on Rewari Sadulpur Line) Rewari Mohindergarh Road (SH-24) at km. 22.100",
    "client": "JC Technocrats Pvt. Ltd."
  },
  {
    "id": 119,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of 65m Span MJB PMT at km 0.010 on Road Kargil Town Bye Pass (Over Suru River)",
    "client": "M/s Wazi Steel Engineering Product"
  },
  {
    "id": 120,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Structural Design and Drawing of Tower Foundation for 40m High Tower",
    "client": "Bharat Sanchar Nigam Ltd."
  },
  {
    "id": 121,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Proof Load Testing for the Bridge on KM 236+600 to KM 239+480 and KM 244+750 to KM 287+710",
    "client": "Rajinder Infrastructure Pvt. Ltd."
  },
  {
    "id": 122,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of the Design and Drawings of Bridges (2*40 m) for BRO",
    "client": "Sanjeev Kumar Goyal Contractor"
  },
  {
    "id": 123,
    "researcher": "Dr. Naveen James",
    "title": "Vetting of the Geotechnical Investigation Report",
    "client": "Ahluwalia Contracts (India) Ltd."
  },
  {
    "id": 124,
    "researcher": "Dr. Reet Kamal Tiwari (CI) and Dr. Shray Pathak (Co-CI)",
    "title": "Estimate for Field Survey and Preparation of Contour Plan of Reservoir Area, Dam Body and L-Section of Khad of Arniala Dam",
    "client": "WRD Punjab"
  },
  {
    "id": 125,
    "researcher": "Dr. Naveen James and Dr. Reet Kamal Tiwari (CI)",
    "title": "Geological and Geotechnical Study of Bichhohi Dam Kandi Area",
    "client": "Dam Authority"
  },
  {
    "id": 126,
    "researcher": "Dr. Naveen James and Dr. Reet Kamal Tiwari (CI)",
    "title": "Geological and Geotechnical Study of Chak Sadhu Dam Kandi Area",
    "client": "Dam Authority"
  },
  {
    "id": 127,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Various Stagings of OHTs & Solar Structure",
    "client": "Integral Screw Industries"
  },
  {
    "id": 128,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Preliminary Assessment of Structural Model and Issuing a Structural Stability Certificate for 'Article 23 Conveyance Commercial Plot in Sector-A Pocket-1 Situated at Sushant Golf City Sultanpur Road Lucknow (UP)'",
    "client": "Constructive Ideas, M/s Progressive Constructions"
  },
  {
    "id": 129,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Hanger, MES, Chandimandir",
    "client": "M/s Niagara Metals India Ltd, Chandigarh"
  },
  {
    "id": 130,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Preliminary Submission Drawings and Issuing Structural Stability Certification for Commercial Complex Building at Vrindavan by Omaxe Limited",
    "client": "KSONS Buildwell LLP"
  },
  {
    "id": 131,
    "researcher": "Dr. Putul Haldar",
    "title": "Vetting of Structural Drawings of 'Industrial Shed at Sanand, Gujarat'",
    "client": "STRUSKEL, Maharashtra, Pune"
  },
  {
    "id": 132,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Block of 20 Airmen, 7 Block, Mohanbari",
    "client": "Vijay Kumar Garg"
  },
  {
    "id": 133,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Structural Design of Connecting Corridor & Lift Between Main Block and Lab Block at NIH, Roorkee",
    "client": "Executive Engineer (C-II) Dehradun"
  }, {
    "id": 134,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Bunkers and Shelters",
    "client": "OM SAI Enterprises"
  },
  {
    "id": 135,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of Prayagraj Airport Building",
    "client": "Tinny Craft"
  },
  {
    "id": 136,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Structural Design and Drawing RE Wall (Reinforced Earth Wall)",
    "client": "S S Builders"
  },
  {
    "id": 137,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design and Drawing of 2HL Bridges in SAS Nagar",
    "client": "Associated Engineers"
  },
  {
    "id": 138,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Preliminary General Arrangement Submission Drawings and Issuing Structural Stability Certificate for Commercial Building at Ghaziabad by Mr. Vikrant Mavi, M/s Sarna Projects LLP",
    "client": "Constructive Ideas, for M/s Sarna Projects LLP"
  },
  {
    "id": 139,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Quality & Structural Audit for ESIC Staff Quarters in Sector-30, Chandigarh",
    "client": "Employee State Insurance Corporation, Regional Office, Chandigarh"
  },
  {
    "id": 140,
    "researcher": "Dr. Putul Haldar",
    "title": "Proof Checking of Structural Drawings of 'Commercial Property No. B-17-2700/4 Peeruband Jammu Colony'",
    "client": "KB Structural Consultants Ludhiana"
  },
  {
    "id": 141,
    "researcher": "Dr. Aditya Singh Rajput (CI) and Dr. Mitesh Surana (CI)",
    "title": "Consultancy for Structural Audit of Bantalab Flats at Jammu",
    "client": "State Bank of India, Jammu"
  },
  {
    "id": 142,
    "researcher": "Dr. Indramani Dhada (CI) and Prof. Mukesh Sharma (CI), IIT Kanpur",
    "title": "Carrying out Source Apportionment Study, Emission Inventory and Carrying Capacity in terms of Air Pollution for U.T. of Chandigarh-reg.",
    "client": "CPCC Chandigarh"
  },
  {
    "id": 143,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Structure Design and Other Works",
    "client": "S S Builders"
  },
  {
    "id": 144,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana",
    "title": "Structural Stability Certificate for Vardhman City Center (VCC) Ludhiana, Punjab",
    "client": "Pure Infratech, Ludhiana"
  },
  {
    "id": 145,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Design and Drawings of Prayagraj Airport Building (R1)",
    "client": "Tinny Craft"
  },
  {
    "id": 146,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design and Drawings of Laundry and Store Sheds",
    "client": "SteelBuild Infra Projects Pvt. Ltd"
  },
  {
    "id": 147,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana",
    "title": "Vetting of Preliminary General Arrangement Submission Drawings and Issuing Structural Stability Certificate for Proposal Commercial Building At Khasra 587,588, Vill. Maliyana (Near Harman City), Meerut by M/S Anandam Associates 37, Chippi Tank, Meerut",
    "client": "Constructive Ideas, C/O, M/s Anandam Associate 37, Chippi Tank Meerut"
  },
  {
    "id": 148,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Minor Bridge at CH-KM489 on NH-65, Pune-Hyderabad Section",
    "client": "Haripriya Hospitalities"
  },
  {
    "id": 149,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking the Design & Drawings of 60m Truss Bridge",
    "client": "Bhakhra Beas Management Board"
  },
  {
    "id": 150,
    "researcher": "Dr. Putul Haldar",
    "title": "Preparation of Structural Drawings and Proof Checking of NCCBM Work at Bhubaneswar, Odisha",
    "client": "CPWD, Bhubaneswar"
  },
  {
    "id": 151,
    "researcher": "Dr. Muthulingam Subramaniyan",
    "title": "Proof Checking of Structural Design and Drawing RE Wall (Reinforced Earth Wall)",
    "client": "TRADE AND TAXES"
  },
  {
    "id": 152,
    "researcher": "Dr. Ratan Sarmah",
    "title": "Preparation of State Specific Action Plan (SSAP) on Water Sector Himachal Pradesh",
    "client": "JAL SHAKTI Vibhag, HP"
  },
  {
    "id": 153,
    "researcher": "Dr. Naveen James",
    "title": "Vetting the Two Soil Investigation Reports. One for Kochi and another one report from Jorhat site",
    "client": "Shiva Testing and Research Laboratory, Pvt. Ltd."
  },
  {
    "id": 154,
    "researcher": "Dr. Aditya Singh Rajput and Dr. Mitesh Surana (CI)",
    "title": "Vetting of Structural Drawings of Hospital Building in Mohali",
    "client": "Atina Medicare Pvt. Ltd."
  },
  {
    "id": 155,
    "title": "Proof Checking of Structural Drawings of 'Commercial Building to be Built on Property M.C. NO.: B-XX-4066/1251/3-B (UID NO.: B020-00338) cum Plot No.:16-H, 17-H Situated at Sarabha Nagar, Taraf Sunet (Ludhiana)'",
    "researcher": "Dr. Putul Haldar"
  },
  {
    "id": 156,
    "title": "Proof Checking of Structural Drawings of 'Prop. Plan of Miniplex to Be Built at Green City Square Near AIIMS Hospital, Dabwali Road, Bathinda'",
    "researcher": "Dr. Putul Haldar"
  },
  {
    "id": 157,
    "title": "Random verification of Annual Inventory on Hazardous Waste Management.",
    "researcher": "Dr. Indramani Dhada PI, Dr Neel kanth Nirmalkar and Dr Tarak Mondal (members)"
  },
  {
    "id": 158,
    "title": "Climate Change and its Impact on National Water Security.",
    "researcher": "Dr. Sagar Rohidas Chavan"
  },
  {
    "id": 159,
    "title": "Preparation of State-Specific Action Plan (SSAP) on Water Sector for State of Haryana for Haryana Irrigation Research and Management Institute (HIRMI) under National Water Mission.",
    "researcher": "Dr. Sayantan Ganguly (CI), Dr. Reet Kamal Tiwari, Dr. Sagar Rohidas Chavan, Dr. Ratan Sarmah, Dr. Ickkshaanshu Sonkar and Indramani Dhada (Co-CIs)"
  },
  {
    "id": 160,
    "title": "Preparation of State-Specific Action Plan (SSAP) on Water Sector for State of Punjab for Punjab Water resources Department under National Water Mission.",
    "researcher": "Dr. Sagar Rohidas Chavan (CI), Dr. Sayantan Ganguly, Dr. Reet Kamal Tiwari, Dr. Ratan Sarmah, Dr. Ickkshaanshu Sonkar and Indramani Dhada (Co-CIs)"
  },
  {
    "id": 162,
    "title": "Comprehensive Design and Survey of Sustainable Lift Irrigation Schemes in Changer Area of Punjab for Ropar Headworks Division, Ropar, Punjab.",
    "researcher": "Dr. Sagar Rohidas Chavan (CI), Dr. Reet Kamal Tiwari (CI), Dr. Ratan Sarmah, Dr. Sayantan Ganguly, Dr. Ickkshaanshu Sonkar and Dr. Aditya Singh Rajput (CO-CI)"
  },
  {
    "id": 163,
    "title": "Soil erosion hotspot study for catchment area of Ranjit Sagar Dam project.",
    "researcher": "Dr. Reet Kamal Tiwari and Dr. Sagar Rohidas Chavan (CI)"
  },
  {
    "id": 164,
    "title": "Third-Party Test of Soil – California Bearing Ratio (CBR) Test.",
    "researcher": "Dr. Naveen James"
  },
  {
    "id": 165,
    "title": "Consultancy work at the Rajpura Thermal Plant for Ash Pond Evacuation.",
    "researcher": "Dr. Naveen James"
  },
  {
    "id": 166,
    "title": "Survey, Hydrological and Geotechnical analysis of Siswan River, Punjab.",
    "researcher": "Dr. Reet Kamal Tiwari, Dr. Sagar Rohidas Chavan and Dr. Resmi Sebastian (CIs)"
  },
  {
    "id": 167,
    "title": "Vetting of Structural Design and Drawings of OHRs with Seven Different Capacities.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 168,
    "title": "Condition Assessment, Structural Stability Analysis, and Preparation of Befitting Repair/Retrofitting Strategy for various warehouse structures.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 169,
    "title": "Special Repair to East Gate Security Wall at Fort William, Kolkata.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 170,
    "title": "Structural Design of Gate at Vijay Smarak Security Wall Fort William Kolkata.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 171,
    "title": "Vetting of Bridge Substructure, Lakhanpur, Odisha.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 172,
    "title": "Vetting of Structural Design and Drawings of a Commercial Building in Jalandhar.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 173,
    "title": "Proof-checking of structural drawings of the national centre for sports coaching.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 161,
    "title": "Structural Audit of Existing Masonry Structure, NSNIS, Patiala.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 161,
    "title": "Vetting of structural design and drawing of Sacred Heart Convent School at Bathinda, Punjab.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 161,
    "title": "Vetting of Design and Drawings of Overhead Water Tank of 632 KL capacity.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 161,
    "title": "Proof checking of structural drawings of J&K police housing and ITBP.",
    "researcher": "Dr. Aditya Singh Rajput (CI), Dr. Mitesh Surana (Co-CI)"
  },
  {
    "id": 161,
    "title": "Village Level Survey of 5 villages in Ropar District, Sponsored by Panchayati Raj Division, Rupnagar",
    "researcher": "Dr. Reet Kamal Tiwari (CI)"
  },
  {
    "id": 161,
    "title": "Fixing of Control Points with DGPS at both end of railway tunnels (5 no), of USBRL Project located at Granmorh & Bakalin Reasi Distt. (Jammu and Kashmir) at both ends. Sponsored by Max Infra Pvt Ltd.",
    "researcher": "Dr. Reet Kamal Tiwari (CI)"
  },
  {
    "id": 161,
    "title": "Bathymetric survey of Ranjit Sagar Dam, Punjab, Sponsored by Water Resources Department, Punjab.",
    "researcher": "Dr. Reet Kamal Tiwari (CI)"
  },
  {
    "id": 161,
    "title": "Delineation of soil erosion hotspots and assessment of sediment transfer through magnitude-frequency-analysis in catchment of Bhakra dam, Sponsored by BBMB, India.",
    "researcher": "Dr. Reet Kamal Tiwari (CI)"
  },
  {
    "id": 161,
    "title": "Survey of Operational area of Chandigarh International Airport, Sponsored by CHIAL.",
    "researcher": "Dr. Reet Kamal Tiwari (CI)"
  },
  {
    "id": 161,
    "title": "Fixing of Control Points with DGPS at both end of railway tunnels (8 no), Project located near Anandpur Sahib (Punjab) and Bilaspur (Himachal Pradesh). Sponsored by Max Infra Pvt Ltd.",
    "researcher": "Dr. Reet Kamal Tiwari (CI)"
  }
]

export default function Consultancy() {
  
  return (
    <>
      <Nav />

      <div className="main-container">
        <div className="page-banner">
          <div className="text">
            <p><Link to="https://www.iitrpr.ac.in/civil/" className="backlink" style={{color:"white", textDecoration:"none", cursor:"pointer"}}>Home</Link> / Consultancy</p>
          </div>
        </div>

        <div className="res-middle">
          <div className="res-content">
            <p className="top-p">Consultancy</p>
            <p className="lower-p">Routine Consultancy Program</p>
            <div className="res-list">
              <ul>
                <li>Structural Consultancy</li>
                <li>Geotechnical Consultancy</li>
                <li>Transportation Consultancy</li>
              </ul>
            </div>
            <p className="middle-p" style={{ marginTop: "20px" }}>
              Consultancy Project
            </p>
            <p
              className="middle-p"
              style={{ fontSize: "30px", marginBottom: "15px" }}
            >
              # 33 – Over ₹ 5 Cr.
            </p>

            <p style={{ color: "#4f4f4f" }}>Specialized Consultancy Projects</p>

            {/* ------------table------------------ */}

            <div className="table-div">
              <table>
                <tr>
                  <th>S.No</th>
                  <th>Title</th>
                  <th>CI/Co-CI</th>
                </tr>

                {data.map((item, index) => (

                  <tr key={item.id}>
                    <td>{index+1}</td>
                    <td>{item.title}</td>
                    <td>{item.researcher}</td>
                  </tr>
                ))}
              </table>
            </div>
            
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
